import React, { Component, createRef } from 'react'

export default class Banner extends Component {

    state = { isSticky: false }

    _bannerRef = createRef()

    componentDidMount() {
        // const initialY = getPosition(this._bannerRef.current).y - window.scrollY
        // console.log(this._bannerRef.current, initialY)

        function getPosition(element) {
            var xPosition = 0
            var yPosition = 0

            while(element) {
                xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft)
                yPosition += (element.offsetTop - element.scrollTop + element.clientTop)
                element = element.offsetParent
            }

            return { x: xPosition, y: yPosition }
        }

        window.addEventListener('scroll', e => {
            const { isSticky } = this.state
            const banner = this._bannerRef.current
            const offset = getPosition(banner).y - window.scrollY

            // console.log(offset)

            if (
                (isSticky === false) && (offset <= 0)
            ) {
                // console.log('sticky')
                this.setState({ isSticky: true })
            } else if (
                (isSticky === true) && (offset >= 0)
            ) {
                // console.log('not sticky')
                this.setState({ isSticky: false })
            }
        })
    }

    render() {
        const { text, isDesktop } = this.props
        const { isSticky } = this.state

        return (
            <div
                ref={this._bannerRef}
                className={
                    isDesktop
                        ? 'banner banner--desktop'
                        : 'banner' + (isSticky ? ' banner--sticky' : '')
                }
            >
                <a
                    className="banner__link"
                    href="https://shop.kanomusic.com"
                    target="_blank"
                >{text}</a>
                <a
                    href="http://earlyaccess.kanomusic.com/npn/"
                    target="_blank"
                    className="banner__npn"
                >*no purchase necessary</a>
            </div>
        )
    }
}
